import styled from 'styled-components';

import { Box } from 'components/Box';
import { transition } from 'theme/theme';

export const OverlayDropContent = styled(Box)`
  transition: all ${transition};
`;
